import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
  FaEnvelope, FaLinkedin, FaGithub, FaMapMarkerAlt,
  FaPaperPlane, FaCheck
} from 'react-icons/fa';
import './Contact.css';

const contactInfo = [
  {
    icon: <FaEnvelope />,
    label: 'Email',
    value: 'sudipmazkoti@gmail.com',
    href: 'mailto:sudipmazkoti@gmail.com',
  },
  {
    icon: <FaLinkedin />,
    label: 'LinkedIn',
    value: 'linkedin.com/in/sudipmajkoti',
    href: 'https://www.linkedin.com/in/sudipmajkoti/',
  },
  {
    icon: <FaGithub />,
    label: 'GitHub',
    value: 'github.com/sudipmajkoti07',
    href: 'https://github.com/sudipmajkoti07',
  },
  {
    icon: <FaMapMarkerAlt />,
    label: 'Location',
    value: 'Nepal',
    href: null,
  },
];


const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, subject, message } = formData;
    const body = `Hi Sudip,%0D%0A%0D%0A${encodeURIComponent(message)}%0D%0A%0D%0AFrom:%0D%0A${name}%0D%0A${email}`;
    const mailtoLink = `mailto:sudipmazkoti@gmail.com?subject=${encodeURIComponent(
      subject || 'Inquiry regarding AI Engineer role'
    )}&body=${body}`;
    window.open(mailtoLink, '_self');
    setSent(true);
    setFormData({ name: '', email: '', subject: '', message: '' });
    setTimeout(() => setSent(false), 4500);
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <span className="section-label">[ 07 // INQUIRIES &amp; NETWORK ]</span>
          <h2 className="section-title">Get In Touch</h2>
          <p className="section-subtitle">
            Open to discussing AI Engineer roles, agentic architecture, RAG systems, and collaborative engineering.
          </p>
        </div>

        <motion.div
          className="contact__content"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
        >
          {/* Contact Details Column */}
          <div className="contact__info">
            <h3 className="contact__info-title">Let's Connect</h3>
            <p className="contact__info-desc">
              Whether you are looking to integrate intelligent LLM agents into your workflow, deploy
              production RAG systems, or explore end-to-end MLOps solutions, I would love to hear from you.
            </p>

            <div className="contact__items">
              {contactInfo.map((item, idx) => (
                <div className="contact__item" key={idx}>
                  <div className="contact__item-icon">{item.icon}</div>
                  <div>
                    <span className="contact__item-label">{item.label}</span>
                    {item.href ? (
                      <a href={item.href} target="_blank" rel="noreferrer" className="contact__item-value">
                        {item.value}
                      </a>
                    ) : (
                      <span className="contact__item-value">{item.value}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Form Column */}
          <div className="contact__form-wrap">
            <form className="contact__form" onSubmit={handleSubmit} autoComplete="off">
              <div className="contact__form-group">
                <label htmlFor="name">Your Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="e.g. Jane Doe"
                  required
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>

              <div className="contact__form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="e.g. jane@company.com"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="contact__form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  placeholder="e.g. AI Engineering Collaboration"
                  value={formData.subject}
                  onChange={handleChange}
                />
              </div>

              <div className="contact__form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  placeholder="Share details about the project or opportunity..."
                  required
                  value={formData.message}
                  onChange={handleChange}
                />
              </div>

              <button
                type="submit"
                className={`btn btn-primary contact__submit ${sent ? 'contact__submit--sent' : ''}`}
              >
                {sent ? (
                  <>
                    <FaCheck /> Email Client Opened!
                  </>
                ) : (
                  <>
                    <FaPaperPlane /> Send Message
                  </>
                )}
              </button>
            </form>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default Contact;
